import "./FilterEmpty.scss";

const FilterEmpty = () => {
  return <p className="filter__error">¿¿¿¿Ese quién es???</p>;
};
export default FilterEmpty;
